var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 81,
    height: 81,
    rx: 40.5,
    fill: "#F8B326",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 39.6286V41.0086C55.9981 44.2432 54.9507 47.3906 53.014 49.9813C51.0772 52.572 48.3549 54.4673 45.253 55.3844C42.1511 56.3016 38.8359 56.1914 35.8017 55.0704C32.7675 53.9495 30.177 51.8777 28.4164 49.1642C26.6559 46.4506 25.8197 43.2407 26.0325 40.0131C26.2453 36.7854 27.4958 33.7131 29.5974 31.2542C31.699 28.7953 34.5392 27.0817 37.6943 26.3688C40.8494 25.656 44.1504 25.9821 47.105 27.2986",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 29.0085L41 44.0235L36.5 39.5235",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleContainer);
export default __webpack_public_path__ + "static/media/circle_container.cdda9ff306eebe162ac8359c670ba324.svg";
export { ForwardRef as ReactComponent };